import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const CostCenterNo = ({ column }: HeaderContext<any, unknown>) => {
  const { t } = useTranslation();
  return (
    <DataTableColumnHeader
      column={column}
      title={t("cost_center_abrv")}
      style={{ padding: "5px" }}
    />
  );
};
